import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "checkout" };
import { ref, onMounted, onBeforeUnmount } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StripeCheckout',
    props: {
        secret: {},
        stripeKey: {}
    },
    setup(__props) {
        const props = __props;
        const stripeScript = ref(null);
        function onLoad() {
            stripeScript.value = document.createElement('script');
            stripeScript.value.onload = async () => {
                const stripe = window.Stripe(props.stripeKey);
                const checkout = await stripe.initEmbeddedCheckout({ clientSecret: props.secret });
                checkout.mount('#checkout');
            };
            stripeScript.value.setAttribute('src', 'https://js.stripe.com/v3/');
            document.head.appendChild(stripeScript.value);
        }
        onMounted(() => {
            onLoad();
        });
        onBeforeUnmount(() => {
            window.Stripe = undefined;
            if (stripeScript.value) {
                document.head.removeChild(stripeScript.value);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1));
        };
    }
});
